import requests from "../../services/request";
import store from "../store";
import cookie from "vue-cookies";

export const data = {
  namespaced: true,
  state: {
    workflow: null,
    files: null,
    signed: false,
    auth_token: null,
    revoked: false,
    reference: "",
  },
  actions: {
    personalidentLogin: async ({ commit }, token) => {
      store.commit("set_loading", true);
      return requests
        .getService("personalident/sendSms/" + token)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    createCertificate: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("personalident/createCertificate/" + data.secret, data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getWorkflow: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .getService("workflow/getWorkflow/" + id)
        .then(
          (resp) => {
            commit("set_workflow", resp.data.data);
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    revokeWorkflow: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("signing/revokeWorkflow/" + data.workflow_id + "/" + data.signer_id, { msg: data.msg })
        .then(
          (resp) => {
            commit("set_workflow", resp.data.data);
            commit("set_revoked", true);
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    signWithoutAuth: async ({ commit }) => {
      store.commit("set_loading", true);
      return requests
        .postService("signing/signWithoutAuth")
        .then(
          (resp) => {
            commit("set_signed", true);
            commit("set_auth_token", resp.data.data);
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getWorkflowFiles: async ({ commit }) => {
      store.commit("set_loading", true);
      return requests
        .getService("files/getWorkflowFiles")
        .then(
          (resp) => {
            commit("set_files", resp.data.data);
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getCertificate: async ({ commit }) => {
      store.commit("set_loading", true);
      return requests
        .getService("certificates/getCertificate")
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getSummaryFiles: async ({ commit }) => {
      store.commit("set_loading", true);
      return requests
        .getService("files/getSummaryFiles")
        .then(
          (resp) => {
            commit("set_files", resp.data.data);
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getFile: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .getService("files/getFile/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    sendFilledOutFiles: async ({ commit }, files) => {
      store.commit("set_loading", true);
      return requests
        .putService("files/updateXFDF/", files)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    revokeSMS: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return await requests
        .postService("auth/revokeSMS", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    checkRevokeSMS: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("auth/checkRevokeSMS", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    checkRevokeCredentials: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("auth/checkRevokeCredentials", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    revokeCertificate: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/revokeCertificate", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getSMS: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return await requests
        .postService("auth/getSMS", data)
        .then((resp) => {
          commit("set_auth_token", resp.data.data.id);
          commit("set_reference", resp.data.data.reference);
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getPhone: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return await requests
        .postService("auth/getPhone", data)
        .then((resp) => {
          commit("set_auth_token", resp.data.data.id);
          commit("set_reference", resp.data.data.reference);
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getSMSQualified: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return await requests
        .postService("auth/getSMSQualified", data)
        .then((resp) => {
          commit("set_auth_token", resp.data.data.id);
          commit("set_reference", resp.data.data.reference);
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getPhoneQualified: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return await requests
        .postService("auth/getPhoneQualified", data)
        .then((resp) => {
          commit("set_auth_token", resp.data.data.id);
          commit("set_reference", resp.data.data.reference);
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    checkSMS: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("auth/checkSMS/", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    checkCertificatePassword: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("auth/checkCertificatePassword/", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    retrySMS: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("auth/retrySMS/", data)
        .then(
          (resp) => {
            commit("set_auth_token", resp.data.data.id);
            commit("set_reference", resp.data.data.reference);
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    signNow: async ({ commit }, data) => {
      store.commit("set_loading", true);
      store.commit("set_overlay", true);
      return requests
        .postService("signing/signWorkflow", data)
        .then(
          (resp) => {
            commit("set_signed", true);
            return Promise.resolve(resp);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
          store.commit("set_overlay", false);
        });
    },
    signNowQes2Fa: async ({ commit }, data) => {
      store.commit("set_loading", true);
      store.commit("set_overlay", true);
      return requests
        .postService("signing/signNowQes2Fa", data)
        .then(
          (resp) => {
            commit("set_signed", true);
            return Promise.resolve(resp);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
          store.commit("set_overlay", false);
        });
    },
    signNowQES: async ({ commit }, data) => {
      store.commit("set_loading", true);
      store.commit("set_overlay", true);
      return requests
        .postService("signing/signWorkflowQES", data)
        .then(
          (resp) => {
            commit("set_signed", true);
            return Promise.resolve(resp);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
          store.commit("set_overlay", false);
        });
    },
    getCertificatesByEmail: async ({ commit }, email) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/getCertificatesByEmail/", email)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    changePhone: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/changePhone", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    changePassword: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/changePassword", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    sendOTP: async ({ commit }, email) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/sendOTP", email)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    checkOTP: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("auth/checkOTP", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getSignerByEmail: async ({ commit }, email) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/getSignerByEmail/", email)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getEmailById: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/getEmailById", id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getAccountInformations: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .getService("account/accountInformations/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getAccountAdministrator: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .getService("account/getAccountAdministrator/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getOrganization: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .getService("account/getOrganization/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getLicense: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .getService("account/getLicense/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    addToken: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/addToken/" + data.id + "/" + data.name)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    disableToken: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .deleteService("account/disableToken/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getInterface: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .getService("interface/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getInterfaces: async () => {
      store.commit("set_loading", true);
      return requests
        .getService("interface/")
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getInterfaceByWorkflow: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .getService("interface/getInterfaceByWorkflow/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    putInterface: async ({ commit }, data) => {
      store.commit("set_loading", true);
      let id = data.id;
      delete data.id;
      return requests
        .postService("interface/editInterface/" + id, data)
        .then(
          (resp) => {
            commit;
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    resetInterface: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .putService("interface/reset/" + id)
        .then(
          (resp) => {
            commit("set_user", JSON.stringify(resp.data.data));
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    updateAccountAdministrator: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .putService("account/updateAccountAdministrator", data)
        .then(
          (resp) => {
            commit("set_user", JSON.stringify(data));
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    updateAccountAdministratorRole: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .putService("account/updateAccountAdministratorRole", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    updateOrganization: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .putService("account/updateOrganization", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    addAddress: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("account/addAddress", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    updateAddress: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .putService("account/updateAddress", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    deleteAddress: async ({ commit }, id) => {
      store.commit("set_loading", true);
      return requests
        .deleteService("account/deleteAddress/" + id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    updateTokenName: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .putService("account/updateTokenName", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    updateTokenApiKey: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .putService("account/updateTokenApiKey/" + data.id, data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    startNect: async ({ commit }, data) => {
      store.commit("set_loading", true);
      cookie.set("auth-token", JSON.parse(localStorage.getItem("header"))["accessToken"], 60 * 30);
      return await requests
        .postService("auth/startNect", data)
        .then((resp) => {
          cookie.set("nect-token", resp.data.data.nect_uuid, 60 * 30);
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    startNectRevoke: async ({ commit }, data) => {
      store.commit("set_loading", true);
      if (data.cetificate_id !== "undefined") {
        cookie.set("certificate_id", data.certificate_id, 60 * 30);
      }
      return await requests
        .postService("auth/startNectRevoke", data)
        .then((resp) => {
          cookie.set("nect-token", resp.data.data.nect_uuid, 60 * 30);
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    startOdis: async ({ commit }) => {
      store.commit("set_loading", true);
      cookie.set("auth-token", JSON.parse(localStorage.getItem("header"))["accessToken"], 60 * 30);
      return await requests
        .getService("auth/startOdis")
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    odisCallback: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return await requests
        .postService("auth/odisCallback", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    checkNect: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return await requests
        .postService("auth/checkNect", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getFileToSign: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .getService("files/getFileToSign/" + data.signer_id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    addExistingSignatureRequestData: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("signing/addExistingSignatureRequestData", data)
        .then(
          (resp) => {
            commit("set_file_to_sign", resp.data.data);
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    checkRequestStatus: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .getService("signing/checkRequestStatus/" + data.signer_id)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    getRequestSMS: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return await requests
        .getService("auth/getRequestSMS/" + data)
        .then((resp) => {
          commit("set_auth_token", resp.data.data.id);
          commit("set_reference", resp.data.data.reference);
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    retryRequestSMS: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .getService("auth/retryRequestSMS/" + data)
        .then(
          (resp) => {
            commit("set_auth_token", resp.data.data.id);
            commit("set_reference", resp.data.data.reference);
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    checkRequestSMS: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("auth/checkRequestSMS/", data)
        .then((resp) => {
          return Promise.resolve(resp.data.data);
        })
        .catch((error) => {
          return Promise.reject(error);
        })
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
    uploadFile: async ({ commit }, data) => {
      store.commit("set_loading", true);
      return requests
        .postService("files/uploadFile", data)
        .then(
          (resp) => {
            return Promise.resolve(resp.data.data);
          },
          (error) => {
            return Promise.reject(error);
          }
        )
        .finally(() => {
          store.commit("set_loading", false);
        });
    },
  },
  getters: {
    workflow(state) {
      return state.workflow;
    },
    files(state) {
      return state.files;
    },
    signed(state) {
      return state.signed;
    },
    revoked(state) {
      return state.revoked;
    },
    auth_token(state) {
      return state.auth_token;
    },
    reference(state) {
      return state.reference;
    },
  },
  mutations: {
    set_workflow(state, data) {
      state.workflow = data;
    },
    set_files(state, data) {
      state.files = data;
    },
    set_signed(state, data) {
      state.signed = data;
    },
    set_revoked(state, data) {
      state.revoked = data;
    },
    set_auth_token(state, data) {
      state.auth_token = data;
    },
    set_reference(state, data) {
      state.reference = data;
    },
  },
};
